import * as Yup from "yup";

export const courseSchema = Yup.object().shape({
  title: Yup.string().required("Course title is required"),
  duration: Yup.string().required("Duration is required"),
  accompany_people: Yup.string().required("Number of people is required"),
  batch_type: Yup.string().required("Batch type is required"),
  languages: Yup.string().required("Languages are required"),
  price: Yup.string().required("Price is required"),
  about_course: Yup.string().required("Course description is required"),
  course_content: Yup.array()
    .of(
      Yup.object().shape({
        content_title: Yup.string().required("Content title is required"),
        sub_content: Yup.array()
          .of(Yup.string().required("Sub content is required"))
          .min(1, "At least one sub content is required"),
      })
    )
    .min(1, "At least one course content is required"),
  age: Yup.string().required("Age requirement is required"),
  eligibility: Yup.string().required("Eligibility is required"),
  weekend_start_time: Yup.string().required("Weekend start time is required"),
  weekend_end_time: Yup.string().required("Weekend end time is required"),
  weekday_start_time: Yup.string().required("Weekday start time is required"),
  weekday_end_time: Yup.string().required("Weekday end time is required"),
  thumbnail: Yup.string().required("Thumbnail is required"),
  banner: Yup.string().required("Banner is required"),
  mobile_banner: Yup.string().required("Mobile banner is required"),
  category: Yup.string().required("Category is required"),
});

// course_content: Yup.array()
// .of(
//   Yup.object().shape({
//     content_title: Yup.string().required("Content title is required"),
//     sub_content: Yup.array()
//       .of(Yup.string().required("Sub content is required"))
//       .min(1, "At least one sub content is required"),
//   })
// )
// .min(1, "At least one course content is required"),

export const scheduleSchema = Yup.object().shape({
  course_id: Yup.string().required("Course is required"),
  start_date: Yup.date().required("Start date is required"),
  end_date: Yup.date().required("End date is required"),
  batch_type: Yup.string().required("Batch type is required"),
  batch_start_time: Yup.string().required("Start time is required"),
  batch_end_time: Yup.string().required("End time is required"),
  location: Yup.string().required("Location is required"),
  instructor: Yup.string().required("Instructor is required"),
});
